import { Anchor } from "../Anchor";
import { Button, Col, Row } from "antd";
import { Link } from "react-router-dom";
import React from "react";
import styled from "styled-components";

export const MenuButton = ({ menuButton = {}, ...buttonProps }) => {
	const {
		isExternal = false,
		link,
		text,
		icon,
		...menuButtonProps
	} = menuButton;

	const Button = () => (
		<StyledButton {...buttonProps} {...menuButtonProps} shape="round">
			<Row justify="center" align="middle" gutter={10}>
				{icon && <Col>{icon}</Col>}
				<Col>{text}</Col>
			</Row>
		</StyledButton>
	);

	const noLinkActions = ["openModal", "openDrawer", "logout"];

	return (
		<>
			{!!link && isExternal && (
				<Anchor link={link}>
					<Button></Button>
				</Anchor>
			)}
			{!link && noLinkActions.includes(menuButtonProps.action) && (
				<Button></Button>
			)}
			{!!link && !isExternal && (
				<Link to={link}>
					<Button></Button>
				</Link>
			)}
		</>
	);
};

const StyledButton = styled(Button)`
	font-family: Montserrat, sans-serif; /* move this to theme in the future */
	font-weight: 700;
	width: 100%;
	&:focus {
		color: #fff;
	}
	${({ action }) => !!action && action !== "logout" && "color: #fff"}
	${({ place, action }) =>
		place === "header" &&
		action !== "openDrawer" &&
		"color: #fff; &:hover { background: #145ab4; color: #fff; }"} /* move to theme */
    ${({ type }) =>
		type === "primary" &&
		"border: none; background: linear-gradient(90deg, rgb(158, 76, 246) 0%, rgb(24, 89, 181) 100%);"}

	${({ roundedOutline }) =>
		roundedOutline && "border: 1px solid white; border-radius: 24px"}
`;
